import {CustomCellRendererProps} from '@ag-grid-community/react';
import { FormattedDateTime } from "../../../date/FormattedDateTime/FormattedDateTime";

export type DateCellProps = CustomCellRendererProps<Date> & {}

export const DateCell = (props: DateCellProps) => {
  const {value} = props

  if (!value) {
    return undefined
  }

  return <FormattedDateTime date={value}/>
}
